"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { ComponentProps } from "react";
import type { FieldError } from "react-hook-form";

import { FormError } from "@homeinstead/ui/components/FormError";
import { Input } from "@homeinstead/ui/components/Input";
import { useId } from "react";
import { InquiryFieldLabel } from "./InquiryFieldLabel";

type InquiryTextFieldProps = Omit<ComponentProps<typeof Input>, "className"> & {
  className?: string;
  error?: FieldError;
  errorClassName?: string;
  label?: string;
  showError: boolean;
  textColor?: TextColor;
};

function InquiryTextField({
  className = "bg-white text-base text-new-beginnings-base",
  error,
  errorClassName,
  id: idProp,
  label,
  showError,
  textColor,
  ...inputProps
}: InquiryTextFieldProps) {
  const generatedId = useId();
  const id = idProp ?? generatedId;

  return (
    <div className="flex flex-col gap-2">
      {label ? (
        <InquiryFieldLabel htmlFor={id} textColor={textColor}>
          {label}
        </InquiryFieldLabel>
      ) : null}
      <Input className={className} id={id} {...inputProps} />
      {showError ? (
        <FormError.span className={errorClassName}>
          {error?.message}
        </FormError.span>
      ) : null}
    </div>
  );
}

export { InquiryTextField };
